<template>
    <form id="searchbox" style="
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;right: 0;left: 0;bottom: 0;
        width: 100vw;
        height: 100vh;
        transition: opacity .2s ease-out;
        opacity: 0;
        z-index: 1001;
        background-color: #0009;
        backdrop-filter: blur(7px);
        visibility: hidden;
    " @click="clickOnSearchArea">
        <input type="text" v-model="searchQuery" class="form-control" style="width: 500px; max-width: 90vw; margin-bottom: 10px; border-radius: 10px;" :placeholder="t('navbar.search') + '...'">
        <button type="submit" class="btn btn-green" style="border-radius: 10px;" @click="search">{{ t('navbar.search') }}</button>
    </form>
    <div id="mobile_menu_box" @click="closeMobileMenu($event, true)">
        <menu id="mobile_menu">
            <span @click="closeMobileMenu">&times;</span>
            <li v-for="(item, id) in navbar" :key="id" @click="openMenu($event, item)" v-show="item">
                {{ (item ? item.name : '').format({
                    "ali-ibn-musa": { fa: 'مدرسه', ar: 'مدرس' },
                    "karimeh": { fa: 'مدرسه', ar: 'مدرس' },
                    "sadr": { fa: 'مدرسه', ar: 'مدرس' },
                    "imam-javad": { fa: 'مدرسه', ar: 'مدرس' },
                    "imam-kazem": { fa: 'مدرسه', ar: 'مدرس' },
                    "imam-sadeq": { fa: 'مدرسه', ar: 'مدرس' },
                    "markaz-qom": { fa: 'مؤسسه', ar: 'مؤسسة' },
                    "markaz-tehran": { fa: 'مؤسسه', ar: 'مؤسسه' },
                    "women-tehran": { fa: 'مدرسه', ar: 'مدرس' },
                    "women-qom": { fa: 'مدرسه', ar: 'مدرس' },
                    "none": { fa: '', ar: '' }
                }[$route.params.school ?? 'none'][locale]) }}
                <span style="float: left;" v-if="item && item.menu">&rang;</span>
                <ul v-if="item && item.menu">
                    <li v-for="(menuItem, index) in item.menu" :key="index" @click="menuItemClicked($event, menuItem.link, true)">
                        {{ menuItem.title }}
                    </li>
                </ul>
            </li>
        </menu>
    </div>
    <div class="header">
        <div class="contain-head">
            <div class="header-logo">
                <router-link :to="$route.params.locale ? `/${$route.params.locale}` : '/'">
                    <img src="@/assets/logo-header.png" alt="Logo">
                </router-link>
                <router-link v-if="$route.params.school" :to="($route.params.locale ? `/${$route.params.locale}/` : '/') + $route.params.school" style="color: whitesmoke; margin-right: 20px; font-weight: bold">{{ {
                    "ali-ibn-musa": { fa: 'مدرسهٔ علی ابن موسی الرضا (علیهماالسلام)', ar: 'مدرس علي‌بن موسی الرضا (عليهماالسلام)' },
                    "karimeh": { fa: 'مدرسهٔ کریمه اهل بیت (سلام الله علیها)', ar: 'مدرس کريمة اهل‌بیت (سلام الله عليها)' },
                    "sadr": { fa: 'مدرسهٔ صدر بازار', ar: 'مدرس صدر' },
                    "imam-javad": { fa: 'مدرسهٔ امام جواد (علیه السلام)', ar: 'مدرس الإمام الجواد (عليه السلام)' },
                    "imam-kazem": { fa: 'مدرسهٔ امام کاظم (علیه السلام)', ar: 'مدرس الإمام کاظم (عليه السلام)' },
                    "imam-sadeq": { fa: 'مدرسهٔ امام صادق (علیه السلام)', ar: 'مدرس الإمام صادق (عليه السلام)' },
                    "markaz-qom": { fa: 'مؤسسه آموزش عالی حوزوی - شعبه قم', ar: 'مؤسسة التعلیم العالی - في القم' },
                    "markaz-tehran": { fa: 'مؤسسه آموزش عالی حوزوی - شعبه تهران', ar: 'مؤسسه التعلیم العالی - في الطهران' },
                    "women-tehran": { fa: 'مدرسهٔ مشکات اندیشه خواهران تهران', ar: 'مدرس مشکاة للنساء - طهران' },
                    "women-qom": { fa: 'مدرسهٔ مشکات اندیشه خواهران قم', ar: 'مدرس مشکاة للنساء - قم' },
                    "none": { fa: '', ar: '' }
                }[$route.params.school ?? 'none'][locale] }}</router-link>
            </div>

            <div class="head-left">
                <div class="menu-icon" @click="openMobileMenu" style="cursor: pointer;">
                    <img src="@/assets/men-icon.png" alt="menu">
                </div>
                <div class="register">
                    <router-link :to="$route.params.locale ? `/${$route.params.locale}/login` : '/login'">{{ cookies.isKey('name') ? t('navbar.logout') : t('navbar.login') }}</router-link>
                </div>
                <div style="color: white; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-weight: bold; font-size: 160%; cursor: pointer;" @click="toggleLanguage">
                    {{ locale == 'fa' ? 'Ar' : 'Fa' }}
                </div>
                <div class="search" style="cursor: pointer;" @click="showSearchbox">
                    <svg xmlns="http://www.w3.org/2000/svg" height="100%" style="fill: white;" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
                </div>
                <div class="pic">
                    <img src="@/assets/emam-agha.png" alt="imam & agha">
                </div>
            </div>
            <nav class="main-menu">
                <ul>
                    <li v-for="(item, id) in navbar" @click.prevent="navbarItemClicked(item)" :key="id" v-show="item">
                        <router-link v-if="item && item.link" :to="item.link.format($route.params.school)" @click.prevent="navbarItemClicked(item)">{{ (item ? item.name : '').format({
                                "ali-ibn-musa": { fa: 'مدرسه', ar: 'مدرس' },
                                "karimeh": { fa: 'مدرسه', ar: 'مدرس' },
                                "sadr": { fa: 'مدرسه', ar: 'مدرس' },
                                "imam-javad": { fa: 'مدرسه', ar: 'مدرس' },
                                "imam-kazem": { fa: 'مدرسه', ar: 'مدرس' },
                                "imam-sadeq": { fa: 'مدرسه', ar: 'مدرس' },
                                "markaz-qom": { fa: 'مؤسسه', ar: 'مؤسسة' },
                                "markaz-tehran": { fa: 'مؤسسه', ar: 'مؤسسه' },
                                "women-tehran": { fa: 'مدرسه', ar: 'مدرس' },
                                "women-qom": { fa: 'مدرسه', ar: 'مدرس' },
                                "none": { fa: '', ar: '' }
                            }[$route.params.school ?? 'none'][locale]) }}</router-link>
                        <a v-else>
                            {{ (item ? item.name : '').format({
                                "ali-ibn-musa": { fa: 'مدرسه', ar: 'مدرس' },
                                "karimeh": { fa: 'مدرسه', ar: 'مدرس' },
                                "sadr": { fa: 'مدرسه', ar: 'مدرس' },
                                "imam-javad": { fa: 'مدرسه', ar: 'مدرس' },
                                "imam-kazem": { fa: 'مدرسه', ar: 'مدرس' },
                                "imam-sadeq": { fa: 'مدرسه', ar: 'مدرس' },
                                "markaz-qom": { fa: 'مؤسسه', ar: 'مؤسسة' },
                                "markaz-tehran": { fa: 'مؤسسه', ar: 'مؤسسه' },
                                "women-tehran": { fa: 'مدرسه', ar: 'مدرس' },
                                "women-qom": { fa: 'مدرسه', ar: 'مدرس' },
                                "none": { fa: '', ar: '' }
                            }[$route.params.school ?? 'none'][locale]) }}
                        </a>
                        <ul v-if="item && item.menu">
                            <li v-for="(menuItem, index) in item.menu" :key="index" @click="menuItemClicked($event, menuItem.link)">
                                <router-link :to="($route.params.locale ? `/${$route.params.locale}` : '') + menuItem.link">{{ menuItem.title }}</router-link>
                                <div :class="['left', index > 0 ? 'only-upwards' : false]" style="color: white;">
                                    <button type="button" v-if="auth.pages.move && index > 0" :style="[index == 0 ? 'visibility: hidden' : '']" :title="t('navbar.moveUp')" @click.prevent="moveUpward(menuItem.id)">⮝</button>
                                    <button type="button" v-if="auth.pages.move && index < item.menu.length - 1" :style="[index == item.menu.length - 1 ? 'visibility: hidden' : '']" :title="t('navbar.moveDown')" @click.prevent="moveDownward(menuItem.id)">⮟</button>
                                    {{ auth.pages.move && (auth.pages.edit || auth.pages.delete) && item.menu.length > 1 ? '|' : '' }}
                                    <button type="button" v-if="auth.pages.edit" class="edit" title="ویرایش صفحه" @click.prevent="editItem(menuItem, id)">✎</button>
                                    <button type="button" v-if="auth.pages.delete" class="remove" title="حذف صفحه" @click.prevent="deleteItem(menuItem)" style="font-size: 2rem;">&times;</button>
                                </div>
                            </li>
                            <li v-if="auth.pages.create" @click="$router.push(($route.params.locale ? `/${$route.params.locale}` : '') + '/new-page/' + (id + 1))">
                                <a href="#">
                                    {{ t('navbar.newPage') }}
                                </a>
                            </li>
                        </ul>
                    </li>

                </ul>
            </nav>
        </div>
    </div>
</template>

<script setup>

import { onMounted, ref, watch } from 'vue'
import $ from 'jquery'
import { useAuth } from '@/authentication'
import { useRouter, useRoute } from 'vue-router'
import { useCookies } from 'vue3-cookies'
import { useI18n } from 'vue-i18n'

const auth = useAuth()
const $router = useRouter()
const $route = useRoute()
const cookies = useCookies().cookies
const { t, locale } = useI18n()

const navbar = ref(null)
const searchQuery = ref("")

// const aboutSchoolPaths = {
//     "ali-ibn-musa": ['schools', !1],
//     "karimeh": ['schools', !1],
//     "sadr": ['schools', !1],
//     "imam-javad": ['schools', !1],
//     "imam-kazem": ['schools', !1],
//     "imam-sadeq": ['schools', !1],
//     "markaz-qom": ['centers', 'qom'],
//     "markaz-tehran": ['centers', 'tehran'],
//     "women-tehran": ['schools/women', 'tehran'],
//     "women-tehran": ['schools/women', 'qom'],
//     "undefined": []
// }

// setTimeout(() => {
//     locale.value = 'ar'
// }, 5000);

function toggleLanguage() {
    var name = $route.name,
        curLang = /arabic$/ig.test(name) ? 'ar' : 'fa',
        nextLang = ['ar','fa'][['fa','ar'].indexOf(curLang)],
        // url = $route.fullPath.replaceAll(/^.(ar|fa)\/?/ig, '').replaceAll(/\/$/g, '')
        url = /^(\/(ar|fa))?(?<url>.*)$/ig.exec($route.fullPath).groups.url.replaceAll(/\/$/g, '')
    
    location.href = `/${nextLang}${url}`
}

function loadNavbarItems(afterLoad = () => {}) {
    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}${$route.params.locale || 'fa'}/navbar-items` + ($route.params.school ? `/school` : ''),
        method: "GET",
        dataType: "json",
        xhrFields: { withCredentials: true },
        success(data) {
            if (data.STATUS) {
                const buttons = data.BUTTONS
                const menus = data.MENUS;
                navbar.value = []
                buttons.forEach(v => {
                    var {id,name} = v, link = v.direct_link
                    navbar.value[id - 1] = {name,link}
                })
                for(const k in menus) {
                    const v = menus[k]
                    var sp = k.split("@"), name = sp[0], menu_id = sp[1]
                    navbar.value[menu_id - 1] = { name, menu:[] }
                    v.forEach(v2 => {
                        var {id,title,link} = v2
                        navbar.value[menu_id - 1].menu.push({id,title,link})
                    })
                }

                afterLoad()
            }
        }
    })
}

onMounted(() => {
    loadNavbarItems()
})
watch(locale, async () => loadNavbarItems())
watch($route, async () => loadNavbarItems())


// setTimeout(loadNavbarItems, 5000)


function navbarItemClicked(item, schoolName = () => $route.params.school ?? undefined) {
    // console.log(item)
    // console.log(schoolName())
    // console.log(aboutSchoolPaths[schoolName()])
    // console.log(item.link.format(item.link.includes('{1}') ? (aboutSchoolPaths[schoolName()] ?? []).map(n => n || schoolName()).reverse() : schoolName()))
    // if (item.link) $router.push(($route.params.locale ? `/${$route.params.locale}` : '') + item.link.format(item.link.includes('{1}') ? (aboutSchoolPaths[schoolName()] ?? []).map(n => n || schoolName()).reverse() : schoolName()))
    if (item.link) $router.push(($route.params.locale ? `/${$route.params.locale}` : '') + item.link.format(schoolName()))
}

function showSearchbox() {
    $("form#searchbox").css({ visibility: 'visible' })
    $("form#searchbox").css({ opacity: 1 })
}

function search() {
    if (searchQuery.value.length) {
        $router.push(`${$route.params.locale ? `/${$route.params.locale}` : ''}/search/${searchQuery.value}`)
        $("form#searchbox").css({ opacity: 0 })
        setTimeout(() => $("form#searchbox").css({ visibility: 'hidden' }), 200)
    }

}

function clickOnSearchArea($event) {
    if ($event.srcElement == $("form#searchbox")[0]) {
        $("form#searchbox").css({ opacity: 0 })
        setTimeout(() => $("form#searchbox").css({ visibility: 'hidden' }), 200)
    }
}

function moveUpward(item_id) {
    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}move-navbar-item-upward`,
        method: "POST",
        xhrFields: { withCredentials: true },
        dataType: "json",
        data: { item_id },
        success(data) {
            if (data.STATUS) {
                loadNavbarItems();
            } else {
                alert(data.REASON)
            }
        }
    })
}

function moveDownward(item_id) {
    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}move-navbar-item-downward`,
        method: "POST",
        xhrFields: { withCredentials: true },
        dataType: "json",
        data: { item_id },
        success(data) {
            if (data.STATUS) {
                loadNavbarItems();
            } else {
                alert(data.REASON)
            }
        }
    })
}

function deleteItem(item) {
    if (confirm(t('navbar.delConfirm', [item.title]))) {
        $.ajax({
            url: `${process.env.VUE_APP_SERVER_ROOT}delete-navbar-item`,
            method: "POST",
            xhrFields: { withCredentials: true },
            dataType: "json",
            data: { item_id: item.id },
            success(data) {
                if (data.STATUS) {
                    loadNavbarItems();
                    alert("حذف شد")
                    $router.push($route.params.locale ? `/${$route.params.locale}` : '/')
                } else {
                    alert(data.REASON)
                }
            }
        })
    }
}

function editItem(item, navItemId) {
    $router.push(($route.params.locale ? `/${$route.params.locale}` : '') + '/edit-page/' + (navItemId + 1) + '/' + item.id)
}

function menuItemClicked($e, link) {
    if(!["BUTTON", "A"].includes($e.target.nodeName)) {
        $router.push(($route.params.locale ? `/${$route.params.locale}` : '') + link)
    }
}

function openMobileMenu() {
    $('[id*=mobile_men]').toggleClass('shown').css({ visibility: 'visible' })
}

function closeMobileMenu($e, area = false) {
    if (area && !$e.target.querySelector('#mobile_menu')) return false;
    $('[id*=mobile_men], menu li ul').removeClass('shown')

    setTimeout(() => {
        $('[id*=mobile_men]').css({ visibility: 'hidden' })
    }, 250);
}

function openMenu($e, item) {
    if (item.menu && $e.target.querySelector('ul')) {
        Array.from(document.querySelectorAll('menu li ul')).filter(n => n != $e.target.querySelector('ul')).forEach(n => n.classList.remove('shown'))
        $e.target.querySelector('ul').classList.toggle('shown')
    } else {
        navbarItemClicked({...item, link: (item.link ?? '').format($route.params.school) || undefined})
        closeMobileMenu($e)
    }
}

</script>

<style lang="less">

    .register a {
        padding: 5px;
        font-size: 13px;
        color: #8a5f2e;
        transition: all .2s;
        background: #fff;
        font-weight: bold;
        border-radius: 10px;
        width: 7.5vw;
        text-align: center;
        display: block;
        text-decoration: none;
    }
    .register a:hover {
        padding: 5px 10px;
        background: #8a5f2e;
        color: #fff;
        cursor:pointer
    }

    .header {
        width: 100%;
        height: 250px;
        background: linear-gradient(0deg, rgba(39,39,39,0) 0%, rgba(39,39,39,0) 0%, rgba(39,39,39,1) 91%);
        position: absolute;
        z-index: 9997;
    }
    .contain-head {
        margin: 0 auto;
        width: 90%;
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .head-left {
        display: flex;
        margin: 10px 0 0;
        align-items: center;
        justify-content: space-between;
        width: 25%;
    }
    .header-logo {
        margin-top: 20px;

        @media screen and (max-width: 1024px) {
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            align-items: stretch;
        }
    }
    .menu-icon {
        height: 32px;
        display: none;
    }
    .main-menu {
        display: flex;
        width: 90%;
        margin: 0 auto;
        border-top: 1px solid #eeeeee29;
        padding-top: 5px;

        ul { margin: 0; padding: 0; }

        &>ul>li {
            float: right;
            list-style: none;
            position: relative;

            ul {
                position: absolute;
                width: 350px;
                top: 115px;
                right: 0;
                box-shadow: 0 1px 6px #e6e6e6;
                opacity: 0;
                visibility: hidden;
                transition: all .2s ease-in-out;
                z-index: 999;
                background-color: rgba(51,51,51,0.85);
                box-shadow: 0 19px 32px 0 rgba(0,0,0,0.72);
                border-radius: 15px;
                overflow: hidden;

                li {
                    list-style: none;
                    border-bottom: 1px solid #6c6c6c;
                    transition: all .2s;
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;


                    &:hover {
                        background: #209f89;
                        color: white;
                    }

                    a {
                        padding: 9px 15px;
                        display: block;
                        font-weight: normal;
                        color: white;
                    }
                }
            }

            &:hover ul {
                opacity: 1;
                visibility: visible;
                top: 33px;
            }
        }
        &>ul>li {
            &>a {
                padding: 5px 8px;
                display: inline-block;
                font-size: 14px;
                color: white!important;
                font-weight: normal;
                transition: all .2s;

                &:hover {
                    background: #8a5f2e;
                }

                i {
                    margin-right: 5px
                }
            }
        }
    }

    .search {
        height: 32px;
    }

    .left {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-evenly;
        align-items: baseline;
        padding: 10px;

        &.only-upwards {
            justify-content: flex-start;
        }

        button {
            background: none;
            border: none;
            cursor: pointer;
            font-weight: bolder;
            color: #209f89;
            transition: color .2s ease-in-out;
            padding: 0 2px;

            &:hover {
                color: #26b9a0;

                &.edit { color: #f9d349; }
                &.remove { color: #ff1c1c; }
            }

            &.edit { color: #f4cd3f; }
            &.remove { color: #ff0000; }
        }
    }

    li:hover>.left button:not(.edit,.remove) {
        color: #ddd;

        &:hover {
            color: #fff;
        }
    }

    #mobile_menu_box {
        position: fixed;
        top: 0; right: 0; left: 0;
        width: 100vw;
        height: 100vh;
        transition: opacity .2s ease-out;
        opacity: 0;
        z-index: 9998;
        background-color: #0009;
        backdrop-filter: blur(7px);
        visibility: hidden;

        &.shown {
            opacity: 1;
        }

        @media screen and (min-width: 1024px) {
            display: none!important;
        }
    }

    #mobile_menu {
        --margin: 15px;
        position: fixed;
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        padding: 12.5px 0;
        margin: 0 0 0 calc(3 * var(--margin));
        // border-radius: calc(var(--margin) / 2) 0 0 calc(var(--margin) / 2);
        list-style: none;
        top: 0; right: -100px; bottom: 0;
        max-width: 500px;
        width: calc(100vw - 3 * var(--margin));
        max-height: 100vh;
        height: 100vh;
        z-index: 10001;
        background-color: white;
        overflow-x: hidden;
        overflow-y: auto;
        opacity: 0;
        visibility: hidden;
        transition: opacity .2s ease-out, right .3s ease-out;

        &>span {
            position: fixed;
            top: var(--margin);
            left: calc(4 * var(--margin));
            font-size: 150%;
            color: black;
            padding: 2px 15px;
            border-radius: 50%;
            cursor: pointer;
        }

        @media screen and (max-width: 1024px) {
            &.shown {
                opacity: 1;
                right: 0;
            }
        }

        &>li {
            padding: 12.5px 25px;
            transition: background .2s ease-out;
            font-size: 130%;
            flex-flow: column nowrap;
            cursor: pointer;
            border-bottom: 1px solid #ddd;

            &:hover {
                background: linear-gradient(90deg, rgba(32, 159, 137, 1) 0%, rgba(83, 228, 203, 1) 28%, rgba(32, 159, 137, 1) 100%);
                color: white;

                ul.shown {
                    // background-color: #0003;

                    li {
                        transition: background .3s ease-out, font .1s ease-out;
                        background: #0000;
                        &:active {
                            background: #0002;
                            font-size: 77%;
                        }
                    }
                }
            }

            ul {
                padding: 0;
                margin: 3px 3px 0 3px;
                list-style: none;
                border-radius: 5px;
                background-color: #0000;
                display: flex;
                flex-flow: column nowrap;
                font-weight: normal;

                height: max-content;
                max-height: 0;
                overflow-x: hidden;
                overflow-y: hidden;
                transition: max-height .2s ease-out, padding .2s ease-out, background .2s ease-out;

                &.shown {
                    max-height: 80vh;
                    padding: 7px 7px 0 7px;
                    overflow-y: auto;
                }

                li {
                    padding: 9px;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: 75%;
                }
            }
        }
    }
    

</style>